import React, { useContext, useState } from 'react';
import { UserContext } from './UserContext';
import { useNavigate } from 'react-router-dom';
import '../styles/login.css';

const SignIn = ({ onLogin }) => {
  const { setUser, getUserData } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://gnrl-bknd-server.onrender.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage('Login successful! Redirecting...');
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', username);
        localStorage.setItem('userData', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        
        setUser(username);
        
        onLogin(true);
        
        navigate('/', { replace: true });
      } else {
        if (response.status === 404) {
          setMessage('Username not found');
        } else if (response.status === 401) {
          setMessage('Invalid password');
        } else {
          setMessage(data.message || 'Login failed. Please check your credentials.');
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setMessage('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="video-container">
        <div className="logo">
          <img src="/cmpnylogo.jpg" alt="Company Logo" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-input-box">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label>Username</label>
          </div>
          <div className="form-input-box">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label>Password</label>
          </div>
          <div className="form-input-box">
            <input 
              type="submit" 
              value={loading ? 'Logging in...' : 'Login'} 
              disabled={loading} 
            />
          </div>
        </form>
      </div>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default SignIn;